import { useState } from "react";
import { InputAdornment, IconButton } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import RHFTextField, { RHFTextFieldProps } from "./RHFTextField";

export default function RHFPasswordField({ name, ...other }: RHFTextFieldProps) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <RHFTextField
      name={name}
      type={showPassword ? "text" : "password"}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={() => setShowPassword(!showPassword)} edge="end" tabIndex={-1}>
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...other}
    />
  );
}
